import { isValidBasePrice, isValidPrice } from '@acme/b2b/pricing';
import { nonLiteralString } from '@acme/b2b/validators/zod';
import { saleChannelSchema } from '@b2b/types/core';
import * as z from 'zod';


export const inventoryItemSchema = z
  .object({
    id: z.number().optional(),
    name: z
      .string()
      .min(1)
      .refine((value) => value.replace(/\s+/g, '').length > 0),
    description: z.string(),
    quantity: z.number(),
    sku: z.string(),
    type: z.union([
      z.literal('doNotTrack'),
      z.literal('doNotTrackNoTicket'),
      z.literal('membershipCardReplacement'),
      nonLiteralString(),
    ]),
    price: z.string().refine((value) => !isNaN(parseFloat(value)) && isValidPrice(value)),
    basePrice: z
      .string()
      .nullish()
      .transform((value) => {
        return value == null || value.length === 0 ? null : value;
      }),
    printTicket: z.boolean(),
    salesChannels: z.array(saleChannelSchema),
  })
  .superRefine((values, ctx) => {
    if (!isValidBasePrice({ basePrice: values.basePrice, price: values.price })) {
      ctx.addIssue({
        code: 'custom',
        path: ['basePrice'],
      });
    }
  });

export type InventoryItem = z.infer<typeof inventoryItemSchema>;
